export default [{
    path: '/publicPage/priceAdjustmentRules',
    name: 'priceAdjustmentRules',
    component: () => import( /* webpackChunkName: "common" */ './priceAdjustmentRules.vue'),
    meta: {
        authPass: true,
        title: '调价规则功能',
        headerId: 'myFortune'
    }
}];